import React from "react";
import { Link } from "react-router-dom";
import ItemDetailsContent from "./ItemDetailsContent";
import CommentsArea from "./CommentsArea";
import CommentForm from "./CommentForm";
import NewsletterBox from "./NewsletterBox";
import BlogSidebar from "../BlogSidebar/BlogSidebar";
import RelatedBlog from "./RelatedBlog";
import { featuredBlogPost, standardBlogPosts } from "../../config/blogs";
import avatar1 from "../../images/avatar/author-img.png";

const BlogDetailsSection: React.FC = () => {
  return (
    <section className="blog_details_section pt-70">
      <div className="container">
        <div className="single-item-image mb-70">
          <img src={featuredBlogPost.image} alt={featuredBlogPost.title} />
        </div>

        <ItemDetailsContent />

        <div className="row mt-none-30 g-0 align-items-start">
          <div className="col-lg-8 mt-30">
            <div className="blog_details_content">
              <h3 className="item_details_info_heading mb-35">
                Why your website is your most important business asset in 2025
              </h3>

              <div className="row mb-35 mt-none-30">
                <div className="col-md-6 col-sm-6 mt-30">
                  <div className="single-item-image">
                    <img src={standardBlogPosts[0].image} alt="Mobile app development" />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 mt-30">
                  <div className="single-item-image">
                    <img src={standardBlogPosts[1].image} alt="E-commerce website" />
                  </div>
                </div>
              </div>

              <p>
                In 2025, your website is often the first impression customers have of your
                business. A well-designed site builds trust, communicates your value clearly,
                and guides visitors toward action — whether that is a purchase, a booking, or a
                contact inquiry. Businesses that invest in professional design see stronger
                engagement, better conversion rates, and a more credible brand presence online.
              </p>

              <p className="mt-35">
                Beyond aesthetics, a modern website must be fast, mobile-friendly, and easy to
                navigate. Search engines reward sites that load quickly and deliver a smooth
                experience across devices. Security, clear calls to action, and structured
                content all play a role in turning casual visitors into loyal customers.
              </p>

              <h3 className="item_details_info_heading mb-20">
                Key elements of a high-performing business website
              </h3>

              <p className="mb-40">
                A successful business website combines thoughtful design with practical
                functionality. Clear navigation helps users find what they need without
                frustration. Compelling copy explains your services and differentiators. Strong
                visuals reinforce your brand identity. Together, these elements create a
                digital storefront that works around the clock for your business.
              </p>

              <div className="row mb-45 align-items-center mt-none-30">
                <div className="col-md-6 mt-30">
                  <img src={featuredBlogPost.image} alt="Web design" className="single-item-image" />
                </div>

                <div className="col-md-6 mt-30">
                  <ul className="iconlist_block">
                    <li><span className="iconlist_text">Mobile-responsive layout.</span></li>
                    <li><span className="iconlist_text">Fast page load speeds.</span></li>
                    <li><span className="iconlist_text">Clear calls to action.</span></li>
                    <li><span className="iconlist_text">SEO-friendly structure.</span></li>
                    <li><span className="iconlist_text">Secure hosting &amp; SSL.</span></li>
                    <li><span className="iconlist_text">Easy content management.</span></li>
                  </ul>
                </div>
              </div>

              <h3 className="item_details_info_heading mb-25">3 reasons design drives business growth</h3>

              <ul className="iconlist_block numlist_block list-unstyled">
                <li><span className="iconlist_text">1. First impressions build trust instantly.</span></li>
                <li><span className="iconlist_text">2. Good UX keeps visitors engaged longer.</span></li>
                <li><span className="iconlist_text">3. A polished site supports higher conversions.</span></li>
              </ul>

              <div className="post-block-wrap mb-50">
                <div className="postabmin_block xb-border ul_li">
                  <div className="admin_image">
                    <img src={avatar1} alt="Author" />
                  </div>

                  <div className="admin_content">
                    <h4 className="admin_name">{featuredBlogPost.author}</h4>
                    <span className="admin_designation">Web Design Team</span>
                    <p>
                      We help businesses build websites that look professional, perform well,
                      and convert visitors into customers.
                    </p>

                    <ul className="social_icons_blocks list-unstyled ul_li">
                      <li><Link to="/blog-details"><i className="fab fa-facebook-f"></i></Link></li>
                      <li><Link to="/blog-details"><i className="fab fa-instagram"></i></Link></li>
                      <li><Link to="/blog-details"><i className="fab fa-linkedin-in"></i></Link></li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="row mt-none-30">
                <div className="col-md-6 mt-30">
                  <ul className="tags_block list-unstyled">
                    <li><Link className="xb-border" to="/blog-details">Web Design</Link></li>
                    <li><Link className="xb-border" to="/blog-details">Business</Link></li>
                    <li><Link className="xb-border" to="/blog-details">UX</Link></li>
                  </ul>
                </div>

                <div className="col-md-6 mt-30">
                  <ul className="social_icons_block list-unstyled ul_li justify-content-md-end">
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-facebook-f"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-twitter"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-linkedin-in"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-instagram"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fas fa-share-alt"></i></Link></li>
                  </ul>
                </div>
              </div>

              <CommentsArea />
              <CommentForm />
              <NewsletterBox />
            </div>
          </div>
          <BlogSidebar />
        </div>

        <RelatedBlog />
      </div>
    </section>
  );
};

export default BlogDetailsSection;
